export const en = {
  PAGE_NOT_FOUND: "PAGE NOT FOUND",
  BACK_HOME: "BACK TO HOME"
};

export const ar = {
  PAGE_NOT_FOUND: "الصفحة غير موجودة",
  BACK_HOME: "الرجوع الي الصفحة الرئيسية"
};
